import {
  GET_SUBSCRIPTION_STATUS_SUCCESS,
  GET_SUBSCRIPTION_STATUS_ERROR,
} from "../actions/index";

const initialState = {
  statusName: "",
  terminal: false,
  successful: false,
  error: "",
};

// next line is excluded from a sonar because an order of variables is provided by redux
// prettier-ignore
export default (state = initialState, action) => { //NOSONAR
  switch (action.type) {
    case GET_SUBSCRIPTION_STATUS_SUCCESS:
      return {
        ...state,
        ...action.payload.data
      };
    case GET_SUBSCRIPTION_STATUS_ERROR:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
};
